import React from 'react'
import { useTranslation } from 'react-i18next';

import {
  TableHead,
  TableRow,
  TableCell,
  withStyles
} from '@material-ui/core'

import { CommonFonts } from '@/theme'

const TableHeader = () => {
  const { t } = useTranslation()

  const headCells = [
    {
      id: 'date_time',
      label: t('orders.date_time'),
      width: '15%',
    },
    {
      id: 'order_no',
      label: t('orders.order_no'),
      width: '15%',
    },
    {
      id: 'order_type',
      label: t('orders.order_type'),
      width: '15%',
    },
    {
      id: 'user',
      label: t('orders.user'),
      width: '15%',
    },
    {
      id: 'status',
      label: t('orders.status'),
      width: '15%',
    },
    {
      id: 'order_value',
      label: t('orders.order_value'),
      width: '15%',
    },
    {
      id: 'empty',
      label: '',
      width: '10%',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            style={{
              width: headCell.width,
              borderBottom: 'none'
            }}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const StyledTableCell = withStyles(() => ({
  root: {
    borderBottom: 'none',
    ...CommonFonts.darkFont14,
    fontWeight: 'normal'
  },
  head: {
    backgroundColor: '#F3F5F7',
  },
  body: {
    ...CommonFonts.darkFont14
  },
}))(TableCell);


export default TableHeader